export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Navbar.vue?vue&type=template&id=72b2e796&"


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Navbar.vue?vue&type=template&id=72b2e796&
// module id = null
// module chunks = 